import React, { useState } from 'react';
import InterviewScheduleDetails from './InterviewDetails';
import AdditionalInfoForm from './AdditionalInfoForm';
import UnAvailableReasons from './UnavailableReasons';
import '../../../css/Form.css';
import Loader from '../../../helper/Loader';
import ApiGateway from '../../../helper/ApiGateway';
import ERPUtils from '../../../helper/Utils';
import useStateCallback from '../../../helper/asyncSetState';
import Popup from '../../../helper/SuccessPopup';
import { toast } from 'react-toastify';

const FirstRound = (props) => {

	const { interviewDetails, ActiveInterviewRound, closeInterviewModal, getApplicationsData, savedData, ApplicationsPrevData, workFlow } = props;
	//Loader:
	const [LoaderActive, setLoaderActive] = useStateCallback(false);
	// Popup state:
	const [showAlert, setShowAlert] = useStateCallback(false);
	const [ApiError, setApiError] = useState(false);
	// const [warningMsg, setWarmingMsg] = useState(false);
	const [requiredFieldsAlert, showRequiredFieldsAlert] = useState(false);

	// Component State:
	const [RenderData, setRenderData] = useStateCallback(null); // ResearchDetails Data
	const [ReasonsForRej, setReasonsForRej] = useStateCallback([]); // DropDown Data
	const [roundData, setRoundData] = useStateCallback({
		availableForInt: ERPUtils.isUndefinedOrNull(savedData) === false ? savedData.isAvailableForTheInterview : '',
		ResearchDetailsData:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.researchDetailDTO) === false
					? ERPUtils.isUndefinedOrNull(savedData.researchDetailDTO.researchEntries) === false
						? ERPUtils.isUndefinedOrNull(
							savedData.researchDetailDTO.researchEntries.researchEntriesHeadings
						) === false
							? AssignSavedResearchData(savedData.researchDetailDTO.researchEntries.researchEntriesHeadings)
							: {}
						: {}
					: {}
				: {},
		HaveUanNo:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.empApplnPersonalDataDTO) === false
					? savedData.empApplnPersonalDataDTO.isUanNo
					: ''
				: '',
		UanNo:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.empApplnPersonalDataDTO) === false
					? savedData.empApplnPersonalDataDTO.uanNo
					: ''
				: '',
		RejectionReason: '',
		otherReason: ''
	});

	const [RequiedFields, setRequiredFields] = useStateCallback({
		availableForIntReqError: false,
		HaveUanNoReqError: false,
		UanNoReqError: false,
		RejectionReasonReqError: false,
		otherReasonReqError: false
	});

	// Handlers:
	function AssignSavedResearchData(responseData) {
		let arrayObj = {};
		responseData?.map((el) => {
			const modify = { ...arrayObj[el.groupHeading] };
			el.parameters?.map((item) => {
				modify[item.researchParameter] = item.parameterValue;
				arrayObj[el.groupHeading] = modify;
				return '';
			});
			return '';
		});
		return arrayObj;
	}


	const onChangeHandler = (event) => {

		const name = event.target.name;
		const val = event.target.value;
		let oldObj = { ...roundData };
		if (name === 'availableForInt') {
			if (val === 'true') {
				oldObj[name] = val;
				oldObj['RejectionReason'] = '';
				setRoundData(oldObj, () => {
					if (!isShowInterviewDetails() && workFlow !== "EMP_STAGE1_HOD_RESCHEDULED") {
						callAdditionalDataApi()
					}
					changeRequiredStatus('availableForInt');
				});
			} else if (val === 'false') {
				oldObj[name] = val;
				oldObj['ResearchDetailsData'] = {};
				// oldObj['HaveUanNo'] = '';
				// oldObj['UanNo'] = '';
				setRenderData(null);
				setRoundData(oldObj, () => {
					ReasonsApi();
					changeRequiredStatus('availableForInt');
				});
			}
			// } else if (name === 'HaveUanNo') {
			// 	if (val === 'false') {
			// 		oldObj[name] = val;
			// 		oldObj['UanNo'] = '';
			// 		setRoundData(oldObj);
			// 		changeRequiredStatus('HaveUanNo');
			// 	} else {
			// 		oldObj[name] = val;
			// 		setRoundData(oldObj);
			// 		changeRequiredStatus('HaveUanNo');
			// 	}
		} else {
			oldObj[name] = val;
			setRoundData(oldObj);
			changeRequiredStatus(name);
		}
	};

	const ResearchDetailsHandler = (event) => {
		const name = event.target.name;
		const val = event.target.value;
		const ObjName = event.target.title;
		let arrayObj = { ...roundData.ResearchDetailsData };
		const modify = { ...arrayObj[ObjName] };
		modify[name] = val;
		arrayObj[ObjName] = modify;
		setRoundData({
			...roundData,
			ResearchDetailsData: arrayObj
		});
	};

	const selectHandler = (selected) => {
		const oldObj = { ...roundData };
		oldObj['RejectionReason'] = selected;
		oldObj['otherReason'] = '';
		setRoundData(oldObj);
		changeRequiredStatus('RejectionReason');
		if (selected.isReschedulable === true || selected.isReschedulable === "true") {
			setShowAlert(true);
		}
	};

	const changeRequiredStatus = (target) => {
		const oldObj = { ...RequiedFields };
		if (target === 'availableForInt') {
			oldObj['availableForIntReqError'] = false;
			// oldObj['HaveUanNoReqError'] = false;
			// oldObj['UanNoReqError'] = false;
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		// if (target === 'HaveUanNo') {
		// 	oldObj['HaveUanNoReqError'] = false;
		// 	oldObj['UanNoReqError'] = false;
		// }
		// if (target === 'UanNo') {
		// 	oldObj['UanNoReqError'] = false;
		// }
		if (target === 'RejectionReason') {
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		if (target === 'otherReason') {
			oldObj['otherReasonReqError'] = false;
		}
		setRequiredFields(oldObj);
	};

	const CheckRequiredErrors = () => {
		const checkThese = ['availableForInt'];
		const ReqErrors = { ...RequiedFields };
		const available = {
			// HaveUanNo: roundData.availableForInt !== '' ? (roundData.availableForInt === 'true' ? true : false) : false,
			// UanNo: roundData.HaveUanNo !== '' ? (roundData.HaveUanNo === 'true' ? true : false) : false,

			RejectionReason:
				roundData.availableForInt !== '' ? (roundData.availableForInt === 'false' ? true : false) : false,
			otherReason:
				roundData.RejectionReason !== '' ? (roundData.RejectionReason.label === 'Other' ? true : false) : false
		};

		checkThese.map((el) => {
			if (
				ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
				ERPUtils.isNullOrEmpty(roundData[el]) === true ||
				ERPUtils.isNullorWhiteSpace(roundData[el]) === true
			) {
				let name = el + 'ReqError';
				ReqErrors[name] = true;
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return '';
		});

		Object.keys(available).map((el) => {
			if (available[el]) {
				if (
					ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
					ERPUtils.isNullOrEmpty(roundData[el]) === true ||
					ERPUtils.isNullorWhiteSpace(roundData[el]) === true
				) {
					let name = el + 'ReqError';
					ReqErrors[name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors[name] = false;
				}
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return '';
		});

		setRequiredFields(ReqErrors, () => {
			checkForErrors(ReqErrors);
		});
	};

	const checkForErrors = (data) => {
		var allVals = [];
		Object.keys(data).map((el) => {
			allVals.push(data[el]);
			return '';
		});
		if (allVals.indexOf(true) !== -1) {
			RequiredFieldsAlert();
		} else {
			submitData();
		}
		return '';
	};

	// Reschedule popup
	const hideAlert = () => {
		setShowAlert(false);
	};

	// Rejection popup
	// const warningHanlder = () => {
	// 	setWarmingMsg(false);
	// };

	// To Close the error popup
	const closeErrorPopup = () => {
		setApiError(false);
	};

	// To show required fields error popup
	const RequiredFieldsAlert = () => {
		showRequiredFieldsAlert(!requiredFieldsAlert);
	};

	// Api handlers:
	const callAdditionalDataApi = () => {
		setLoaderActive(true);
		let url = 'Employee/CommonEmployee/getResearchDetails';
		ApiGateway.post(url, {}, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							setRenderData(response.data.dto);
						} else {
							setLoaderActive(false);
							setApiError(true);
						}
					} catch (ex) { }
				}
			} catch (ex) {
				setLoaderActive(false);
				setApiError(true);
			}
		});
	};

	const ReasonsApi = () => {
		setLoaderActive(true);
		let url = 'Employee/CommonEmployee/getApplnNonAvailability?interviewRound=';
		let interviewRound =
			ActiveInterviewRound.interviewRound !== undefined ? ActiveInterviewRound.interviewRound : '';
		ApiGateway.post(url + interviewRound, {}, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							let newArray = []
							let otherObj = { value: 'Other', label: 'Other' }
							newArray = !ERPUtils.isUndefinedOrNull(response?.data?.dto) ? response?.data?.dto : []
							newArray.push(otherObj)
							setReasonsForRej(newArray);
							setLoaderActive(false);
						}
						else {
							setLoaderActive(false);
						}
					} catch (ex) {
						setLoaderActive(false);
					}
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	const savedAddnlInfoEntries = (ID) => {
		let data = null;
		if (!ERPUtils.isNullorWhiteSpace(savedData)) {
			const resEntriesdata = savedData.researchDetailDTO?.researchEntries?.researchEntriesHeadings;
			for (let item = 0; item < resEntriesdata?.length; item++) {
				const element = resEntriesdata[item].parameters;
				for (let para = 0; para < element?.length; para++) {
					if (element[para].empApplnAddtnlInfoEntriesId !== null) {
						const result = element[para].id;
						if (result === ID) { // Get the empApplnAddtnlInfoEntriesId if parameters id and Roundata detailsdto id matches..
							data = element[para].empApplnAddtnlInfoEntriesId
							break;
						}
					}
				}
			}
		}
		return data;
	}

	const formResearchDetails = () => {
		let ResearchDataList = [];
		if (RenderData !== null && RenderData.length > 0 && RenderData !== null) {
			RenderData.map((el) => {
				if (
					el.isTypeResearch === false &&
					el.employeeCategoryId === ActiveInterviewRound.empEmployeeCategoryId
				) {
					if (el.detailsDTO.length > 0) {
						let construct = {
							id: el.value,
							isTypeResearch: el.isTypeResearch,
							groupHeading: el.label,
							displayOrder: el.headingDisplayOrder,
							parameters: []
						};

						el.detailsDTO.map((item) => {
							if (item.isDisplayInApplication === true) {
								let innerObj = {
									id: item.value,
									empApplnAddtnlInfoEntriesId: savedAddnlInfoEntries(item.value),
									empApplnEntriesId:
										ActiveInterviewRound.empApplnEntriesId !== undefined
											? ActiveInterviewRound.empApplnEntriesId
											: null,
									displayOrder: item.parameterDisplayOrder,
									researchParameter: item.label,
									isDisplayInApplication: item.isDisplayInApplication,
									parameterValue:
										roundData.ResearchDetailsData[el.label] !== (undefined && null)
											? roundData.ResearchDetailsData[el.label][item.label]
											: null
								};
								return construct.parameters.push(innerObj);
							}
							return '';
						});
						return ResearchDataList.push(construct);
					}
				}
				return '';
			});
		}
		return ResearchDataList.length > 0 ? ResearchDataList : null;
	};

	const isShowInterviewDetails = () => {// Based on workflow we are showing extra link to user
		if (!ERPUtils.isNullorWhiteSpace(savedData)) {
			if ((savedData.applicantWorkFlowStatusCode === "EMP_STAGE1_APPLICANT_ACCEPTED"
				|| savedData.applicantWorkFlowStatusCode === "EMP_STAGE1_SELECTED"
				|| savedData.applicantWorkFlowStatusCode === "EMP_STAGE1_BYPASSED"
				|| savedData.applicantWorkFlowStatusCode === "EMP_STAGE1_HOD_RESCHEDULED") && (
					savedData.applicationWorkFlowStatusCode === "EMP_STAGE1_APPLICANT_ACCEPTED"
					|| savedData.applicationWorkFlowStatusCode === "EMP_STAGE1_SELECTED"
					|| savedData.applicationWorkFlowStatusCode === "EMP_STAGE1_BYPASSED"
					|| savedData.applicationWorkFlowStatusCode === "EMP_STAGE1_HOD_RESCHEDULED")) {
				return true;
			}
			return false;
		}
		return false;
	}


	const submitData = () => {
		var ApiData = {
			empApplnEntriesId:
				ActiveInterviewRound.empApplnEntriesId !== undefined ? ActiveInterviewRound.empApplnEntriesId : null,
			applicationNo: ActiveInterviewRound.applicationNo !== undefined ? ActiveInterviewRound.applicationNo : null,
			empApplnInterviewSchedulesId:
				ActiveInterviewRound.empApplnInterviewSchedulesId !== undefined
					? ActiveInterviewRound.empApplnInterviewSchedulesId
					: null,
			interviewRound:
				ActiveInterviewRound.interviewRound !== undefined ? ActiveInterviewRound.interviewRound : null,
			isAvailableForTheInterview: roundData.availableForInt,
			empApplnNonAvailabilityDTO:
				roundData.availableForInt === 'true'
					? null
					: roundData.RejectionReason.label === 'Other'
						? {
							empApplnNonAvailabilityId: null,
							nonAvailabilityName: roundData.otherReason,
							isReschedulable: null,
							interviewRound:
								ActiveInterviewRound.interviewRound !== undefined
									? ActiveInterviewRound.interviewRound
									: null
						}
						: {
							empApplnNonAvailabilityId: roundData.RejectionReason.value,
							nonAvailabilityName: roundData.RejectionReason.label,
							isReschedulable: roundData.RejectionReason.isReschedulable,
							interviewRound: roundData.RejectionReason.interviewRound
						},
			researchDetailDTO: {
				researchEntries: {
					researchEntriesHeadings: formResearchDetails()
				}
			},
			empApplnPersonalDataDTO: {
				empApplnPersonalDataId:
					ActiveInterviewRound.empApplnPersonalDataId !== undefined
						? ActiveInterviewRound.empApplnPersonalDataId
						: null,
				empApplnEntriesId:
					ActiveInterviewRound.empApplnEntriesId !== undefined
						? ActiveInterviewRound.empApplnEntriesId
						: null,
				isUanNo: roundData.HaveUanNo,
				uanNo: roundData.UanNo
			}
		};
		setLoaderActive(true);
		let url = !isShowInterviewDetails() ? 'Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplicationInterviewDetails' :
			"Employee/Recruitment/EmployeeApplicationControler/submitEmployeResearchData";
		ApiGateway.post(url, ApiData, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							toast.success("Done!")
							getApplicationsData();
						} else {
							setLoaderActive(false);
						}
					} catch (ex) { }
				} else {
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	React.useEffect(() => {
		if (interviewDetails.editable === false) {
			callAdditionalDataApi();
			ReasonsApi();

		}
		else if (isShowInterviewDetails()) {
			callAdditionalDataApi();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);



	return (
		<div>
			<div style={{ height: " auto ", overflow: "auto" }}>
				{isShowInterviewDetails() ? ( // if it is true showing only additional information
					<div>
						<AdditionalInfoForm
							onChangeHandler={onChangeHandler}
							RenderData={RenderData}
							interviewDetails={interviewDetails}
							roundData={roundData}
							ResearchDetailsHandler={ResearchDetailsHandler}
							ActiveInterviewRound={ActiveInterviewRound}
							RequiedFields={RequiedFields}
						/>
					</div>
				) : (
					<>
						<InterviewScheduleDetails interviewDetails={interviewDetails} />
						<div className="parentBoxDiv border" >
							<div className="row" style={{ paddingLeft: '10px' }}>
								<div className="col-md-4 col-xs-12">
									<label className="formExpLabel">
										<span className="requiredText">*</span>
										Available for the interview
									</label>
								</div>
								<div className="col-md-5" style={{ top: '13px' }}>
									<label className="radio-inline">
										<input
											className="space formExpLabel"
											onChange={onChangeHandler}
											type="radio"
											name="availableForInt"
											value="true"
											checked={roundData.availableForInt === 'true'}
											disabled={interviewDetails.editable === false ? true : false}
										/>
										Yes
									</label>
									<label className="radio-inline">
										<input
											className="space formExpLabel"
											onChange={onChangeHandler}
											type="radio"
											name="availableForInt"
											value="false"
											checked={roundData.availableForInt === 'false'}
											disabled={interviewDetails.editable === false ? true : false}
										/>
										No
									</label>
									{RequiedFields.availableForIntReqError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
										</p>
									) : null}
								</div>
							</div>
						</div>
						<div>
							{/* Differtiate first round interview schedule and reshedule interview */}
							{roundData.availableForInt === 'true' && !isShowInterviewDetails() && workFlow !== "EMP_STAGE1_HOD_RESCHEDULED" ? (
								<AdditionalInfoForm
									onChangeHandler={onChangeHandler}
									RenderData={RenderData}
									interviewDetails={interviewDetails}
									roundData={roundData}
									ResearchDetailsHandler={ResearchDetailsHandler}
									ActiveInterviewRound={ActiveInterviewRound}
									RequiedFields={RequiedFields}
								/>
							) : null}

							{roundData.availableForInt === 'false' ? (
								<UnAvailableReasons
									selectHandler={selectHandler}
									ReasonsData={roundData.RejectionReason}
									ReasonsForRej={ReasonsForRej}
									otherReason={roundData.otherReason}
									onChangeHandler={onChangeHandler}
									RequiedFields={RequiedFields}
									interviewDetails={interviewDetails}
								/>
							) : null}
						</div>
					</>
				)}
			</div>
			<div>
				{interviewDetails.editable === false ? null : (
					<div className="buttonsParentTab" >
						<div className="row buttonsChildTab">
							<div className='col d-flex justify-content-center text-center pt-1 pb-2 '>
								<button
									className="myButton DashboardSubmitBtn z-depthButton"
									value="Previous"
									name="PersonalDetails"
									onClick={isShowInterviewDetails() ? submitData : CheckRequiredErrors}
								>
									Submit
								</button>
								<button
									className="myButton DashBoardCancel z-depthButton"
									name="cancel"
									onClick={closeInterviewModal}
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				)}
				{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
				{showAlert ? (
					<Popup
						open={showAlert}
						close={hideAlert}
						msg="We will reschedule the interview and update you the details accordingly."
						icon={<i className="fa fa-check successIcon" aria-hidden="true" />}
					/>
				) : null}
				{/* {warningMsg ? (
				<Popup
					open={warningMsg}
					close={warningHanlder}
					title="Warning!"
					msg="We will reschedule the interview and update you the details accordingly."
				// icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
				/>
			) : null} */}
				{ApiError ? (
					<Popup
						open={ApiError}
						close={closeErrorPopup}
						msg="Error! occourred while loading the data."
						title="Sorry! for the inconvenience occourred"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						hint="Note: Please try again."
						tabName=""
					/>
				) : null}
				{requiredFieldsAlert ? (
					<Popup
						open={requiredFieldsAlert}
						close={RequiredFieldsAlert}
						msg="Some of the Required fields are missing."
						title="Error!"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						tabName=""
					/>
				) : null}
			</div>
		</div >
	);
};

export default FirstRound;
